import React from 'react';
import theme from './FeeInfoIcon.module.scss';
import { Tooltip } from '@/components/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/pro-light-svg-icons';
import { Trans } from '@lingui/react/macro';

interface FeeInfoIconProps {}

const FeeInfoIcon: React.FC<FeeInfoIconProps> = (props) => {
    return (
        <Tooltip dynamicWidth content={<Trans>Price including fees and VAT</Trans>} interactive={false}>
            <span className={theme.container}>
                <FontAwesomeIcon icon={faInfoCircle} fixedWidth />
            </span>
        </Tooltip>
    );
};

export default FeeInfoIcon;
